import { render, staticRenderFns } from "./EditPage.vue?vue&type=template&id=29396c9d&"
import script from "./EditPage.vue?vue&type=script&lang=ts&"
export * from "./EditPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/agent/workspace/SPP/deployment/frontend-erp-spp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('29396c9d')) {
      api.createRecord('29396c9d', component.options)
    } else {
      api.reload('29396c9d', component.options)
    }
    module.hot.accept("./EditPage.vue?vue&type=template&id=29396c9d&", function () {
      api.rerender('29396c9d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/trucking/sales-order/EditPage.vue"
export default component.exports